class WorkInstructionDTO {
  _id;
  title;
  description;
  steps;
  packageId;
  order;
  linkedTasks;
  linkedDocuments;

  constructor(data) {
    this._id = data._id || data.id;
    this.title = data.title;
    this.description = data.description;
    this.steps = data.steps || [];
    this.packageId = data.packageId;
    if (data.order != null) {
      this.order = data.order;
    }
    this.linkedTasks = data.linkedTasks || [];
    this.linkedDocuments = data.linkedDocuments || [];
  }
}

module.exports = WorkInstructionDTO;
